module.exports = __webpack_public_path__ + "img/q1.3d5cf534.svg";